module.exports = __webpack_public_path__ + "media/images/pc/top/recommend-plan-maedori1-e240cf8c915c826e67aa04220e9b9ecb.jpg";